import { getDataAll } from '../utils/dataUtils';
import { SendData } from '../utils/SendData';

export class FcronManager {
    constructor({ elem, scripts = [] }) {
        this.elemExist = !!elem;
        this.elem = elem;
        this.scripts = scripts;
        this.timers = []; // Will store { id, type: 'interval' | 'timeout' }
        this._init();
    }

    closest(selector) {
        return this.elem.closest(selector);
    }

    querySelector(selector) {
        return this.elem.querySelector(selector);
    }

    _init() {
        this.scripts.forEach(script => {
            if ((script.ttl > 0 || script.ttl === 0) && script.url) {
                const task = () => {
                    if (this.elemExist && (!this.elem || !this.elem.isConnected)) {
                        this.destroy();
                        return;
                    }
                    const scriptFunction = new Function('return ' + script.script)();
                    scriptFunction.call(this.elem, script.data);
                };

                const timeoutStart = Number(script.timeoutStart) || 0;

                if (script.ttl === 0) {
                    // If ttl is 0, execute only once
                    if (timeoutStart > 0) {
                        const timeoutId = setTimeout(task, timeoutStart * 1000);
                        this.timers.push({ id: timeoutId, type: 'timeout' });
                    } else {
                        task();
                    }
                } else {
                    // If ttl > 0, execute with interval
                    if (timeoutStart > 0) {
                        const timeoutId = setTimeout(() => {
                            task();
                            const intervalId = setInterval(task, script.ttl * 1000);
                            this.timers.push({ id: intervalId, type: 'interval' });
                        }, timeoutStart * 1000);
                        this.timers.push({ id: timeoutId, type: 'timeout' });
                    } else {
                        task();
                        const intervalId = setInterval(task, script.ttl * 1000);
                        this.timers.push({ id: intervalId, type: 'interval' });
                    }
                }
            }
        });

        if (this.elem) this.elem.destroyFcron = this.destroy.bind(this);
    }

    destroy() {
        this.timers.forEach(timer => {
            if (timer.type === 'interval') {
                clearInterval(timer.id);
            } else {
                clearTimeout(timer.id);
            }
        });
        this.timers = [];
        if (this.elem && this.elem.destroyFcron) {
            delete this.elem.destroyFcron;
        }
    }
}
